import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'

export function aroundTheWorldEnter(friendCode?: number) {
  try {
    const metrics = getMetrics()
    metrics.api.track(EventTypes.AROUND_THE_WORLD_ENTER, friendCode)
  } catch (e) {
    console.error(`Metrics failed because: ${e}`)
  }
}

export function FacebookEnter(data: any): any {
  return {
    content_name: data.name,
  }
}
